function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "New-Icon/FV/Paper",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Safespace",
  x: 0,
  y: 0,
  width: 20,
  height: 20
}), /*#__PURE__*/React.createElement("g", {
  id: "faktura_papierowa",
  transform: "translate(2.000000, 0.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.72,0.35 L6.77,0.35 L6.71,0.35 C6.62340828,0.367105331 6.54356605,0.408762148 6.48,0.47 L1.82,5.16 C1.75876215,5.22356605 1.71710533,5.30340828 1.7,5.39 C1.69532148,5.40972639 1.69532148,5.43027361 1.7,5.45 C1.69566392,5.46976498 1.69566392,5.49023502 1.7,5.51 L1.7,17.85 C1.7,18.1261424 1.92385763,18.35 2.2,18.35 L14.72,18.35 C14.9961424,18.35 15.22,18.1261424 15.22,17.85 L15.22,0.85 C15.22,0.717391755 15.1673216,0.590214799 15.0735534,0.496446609 C14.9797852,0.40267842 14.8526082,0.35 14.72,0.35 Z",
  id: "Path",
  fill: "#48A9A1",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.33,19.7 L0.78,19.7 C0.503857625,19.7 0.28,19.4761424 0.28,19.2 L0.28,6.86 C0.28,6.58385763 0.503857625,6.36 0.78,6.36 L4.94,6.36 L4.94,2.2 C4.94,1.92385763 5.16385763,1.7 5.44,1.7 L13.33,1.7 C13.6039085,1.70532011 13.8246799,1.92609155 13.83,2.2 L13.83,19.2 C13.83,19.3326082 13.7773216,19.4597852 13.6835534,19.5535534 C13.5897852,19.6473216 13.4626082,19.7 13.33,19.7 Z M1.33,18.7 L12.83,18.7 L12.83,2.7 L5.94,2.7 L5.94,6.86 C5.94,7.13614237 5.71614237,7.36 5.44,7.36 L1.28,7.36 L1.33,18.7 Z",
  id: "Shape",
  fill: "#555150"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.09,14 L3.09,14 C2.81609155,13.9946799 2.59532011,13.7739085 2.59,13.5 C2.59,13.2238576 2.81385763,13 3.09,13 L11.09,13 C11.3661424,13 11.59,13.2238576 11.59,13.5 C11.5846799,13.7739085 11.3639085,13.9946799 11.09,14 L11.09,14 Z",
  id: "Path",
  fill: "#48A9A1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.09,17.08 L7.56,17.08 C7.28385763,17.08 7.06,16.8561424 7.06,16.58 C7.06,16.3038576 7.28385763,16.08 7.56,16.08 L11.09,16.08 C11.3661424,16.08 11.59,16.3038576 11.59,16.58 C11.59,16.8561424 11.3661424,17.08 11.09,17.08 Z",
  id: "Path",
  fill: "#48A9A1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.09,11.86 L3.09,11.86 C2.81385763,11.86 2.59,11.6361424 2.59,11.36 C2.59,11.0838576 2.81385763,10.86 3.09,10.86 L11.09,10.86 C11.3661424,10.86 11.59,11.0838576 11.59,11.36 C11.59,11.6361424 11.3661424,11.86 11.09,11.86 Z",
  id: "Path",
  fill: "#48A9A1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.44,7.36001858 L0.78,7.36001858 C0.577306718,7.36175877 0.394453929,7.23853189 0.32,7.05 C0.239391664,6.86478533 0.283363408,6.64892404 0.43,6.51 L5.09,1.85 C5.23285015,1.70994014 5.44543561,1.66851223 5.63042423,1.74468402 C5.81541285,1.8208558 5.93718997,1.99996242 5.94,2.2 L5.94,6.86 C5.94,6.99260824 5.88732158,7.1197852 5.79355339,7.21355339 C5.6997852,7.30732158 5.57260824,7.36001858 5.44,7.36001858 Z M2,6.36 L5,6.36 L5,3.41 L2,6.36 Z",
  id: "Shape",
  fill: "#555150"
})));

var SvgDocuments = function SvgDocuments(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDocuments, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Documents.a97eefa2.svg";
export { ForwardRef as ReactComponent };